// Modules
import React from "react";
import moment from "moment";

// Styles
import "./ConfirmAvailability.sass";

import HeldReservations from '../HeldReservation/HeldReservations';

interface ConfirmProps {
    roomSelected: any,
    selectedDate: any,
    numOfNights: number,
    numGuest: number,
}

export const ConfirmAvailability: React.FC<ConfirmProps> = ({roomSelected, selectedDate, numOfNights, numGuest}) => {

    const checkIn = () => {
        let checkIn = moment(selectedDate).format("DD MMM YYYY");
        return checkIn
    }

    const checkOut = () => {
        let checkIn = moment(selectedDate).format("DD MMM YYYY");
        let checkOut = moment(checkIn, "DD MMM YYYY").add(numOfNights, 'days').format("DD MMM YYYY");
        return checkOut
    }

    return (
        <React.Fragment>
            <div className="confirm-availability">
                <img src={roomSelected.resortImage}/>
                <div className="hotel-information">
                    <p className="bold hotel-name">{roomSelected.name}</p>
                    <p className="address">{roomSelected.city}, {roomSelected.country} {roomSelected.continent}</p>
                    <p className="phone">Phone Number</p>
                    <p className="bold">Room Type</p>
                </div>
                <div className="arrival-info">
                    <div>
                        <p>Arrival Information</p>
                        <p><span>Check In: </span>{checkIn()}</p>
                        <p><span>Check Out: </span>{checkOut()}</p>
                    </div>
                    <div>
                        <p><span># of Nights: </span>{numOfNights}</p>
                        <p><span># of Guests: </span>{numGuest}</p>
                    </div>
                </div>
                <a className="edit-search">Edit My Search</a>
            </div>
          

            <div className="button-tabs">
                <a href="#">Cancel</a>
                <button>Continue</button>
            </div>
        </React.Fragment>
    )


}

export default ConfirmAvailability;
